import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, bool, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type FinancialAssetFormType = {
  readonly financialAssetType: string;
  readonly name: string;
  readonly value: number;
  readonly isUsableForGoals?: boolean;
  readonly clientId?: string | null;
  readonly institution?: string;
  readonly expenseItemId?: string | null;
  readonly note?: string;
};

export const getFinancialAssetFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<FinancialAssetFormType> = (t) => {
  return object({
    financialAssetType: string().required(t(Resources.Validation.Required)),
    name: string().required(t(Resources.Validation.Required)),
    value: number().required(t(Resources.Validation.Required)),
    institution: string(),
    isUsableForGoals: bool(),
    expenseItemId: string().nullable(),
    clientId: string().nullable(),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
